import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || '/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const documentApi = createApi({
  reducerPath: 'documentApi',
  baseQuery,
  tagTypes: ['Documents'],
  endpoints: (builder) => ({
    // Upload document
    uploadDocument: builder.mutation({
      query: ({ formData, employeeId }) => ({
        url: `/documents/upload/${employeeId}`,
        method: 'POST',
        body: formData,
        // Don't set Content-Type header - let browser set it with boundary for FormData
      }),
      invalidatesTags: ['Documents'],
    }),

    // Get documents for an employee
    getEmployeeDocuments: builder.query({
      query: (employeeId) => `/documents/employee/${employeeId}`,
      providesTags: ['Documents'],
    }),

    // Get all documents (admin)
    getAllDocuments: builder.query({
      query: () => '/documents',
      providesTags: ['Documents'],
    }),

    // Get document by ID
    getDocument: builder.query({
      query: (documentId) => `/documents/${documentId}`,
      providesTags: ['Documents'],
    }),

    // Download document
    downloadDocument: builder.query({
      query: (documentId) => ({
        url: `/documents/${documentId}/download`,
        responseHandler: (response) => response.blob(),
      }),
    }),

    // Preview document
    previewDocument: builder.query({
  query: (documentId) => `/documents/${documentId}/preview`,
  responseHandler: (response) => response.blob(),
    }),

    // Update document metadata
    updateDocument: builder.mutation({
      query: ({ documentId, ...updates }) => ({
        url: `/documents/${documentId}`,
        method: 'PUT',
        body: updates,
      }),
      invalidatesTags: ['Documents'],
    }),

    // Delete document
    deleteDocument: builder.mutation({
      query: (documentId) => ({
        url: `/documents/${documentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Documents'],
    }),

    // Get document statistics
    getDocumentStats: builder.query({
      query: () => '/documents/stats',
    }),
  }),
});

export const {
  useUploadDocumentMutation,
  useGetEmployeeDocumentsQuery,
  useGetAllDocumentsQuery,
  useGetDocumentQuery,
  useDownloadDocumentQuery,
  useLazyDownloadDocumentQuery,
  usePreviewDocumentQuery,
  useLazyPreviewDocumentQuery,
  useUpdateDocumentMutation,
  useDeleteDocumentMutation,
  useGetDocumentStatsQuery,
} = documentApi;
